import React, { useEffect, useState } from "react";
import "../Css/custom-new.css";
import OnboardingRadio from "../../../components/onboarding/OnboardingRadio";
import { OnboardingButton } from "../../../components/onboarding/OnboardingButton";
import { fetchAPI } from "../../../utils/fetch";
import { config } from "../../../utils/config";
import OnboardingSelect from "../../../components/onboarding/OnboardingSelect";
import OnboardingInput from "../../../components/onboarding/OnboardingInput";
import OnboardingMultiOptions from "../../../components/onboarding/OnboardingMultiOptions";

const Step2 = ({
  setProgress,
  setStep,
  onboardingData,
  setOnboardingData,
  toneData,
  stepInfo,
  setStepInfo,
}) => {
  const [formData, setFormData] = useState(onboardingData);
  const [error, setError] = useState(null);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [thirdQuestionError, setThirdQuestionError] = useState(null);

  useEffect(() => {
    setIsFirstTime(!onboardingData.tone);
    setProgress(50);
  }, []);

  const isOtherSelected = formData.tone === "Other" || !toneData.includes(formData.tone);

  const updateAPI = async (step, field, value) => {
    try {
      setStepInfo({ step, message: `Updating ${field}...` });
      const response = await fetchAPI.post(
        `${config.urlPlatform}/api/v2/onboarding/add`,
        { withCredentials: true },
        { step, field, value }
      );

      if (response?.data?.success) {
        const updated = { ...formData, [field]: value };
        setFormData(updated);
        setOnboardingData(updated);
        setError(null);
      } else {
        setError(response?.data?.message || "Update failed.");
      }
    } catch (err) {
      setError("Failed to update. Please try again.");
    } finally {
      setStepInfo({ step: -1, message: null });
    }
  };

  const handleToneChange = (value) => {
    setIsFirstTime(false);
    const toneValue = value === "Other" ? "Other" : value;
    console.log('TONE VALUE', toneValue)
    if (!toneValue || toneValue.trim() === "") {
      setThirdQuestionError("Please select a tone.");
      return;
    };
    setFormData((prev) => ({ ...prev, tone: toneValue }));

    if (value !== "Other") {
      updateAPI(3, "tone", toneValue);
    }
    setThirdQuestionError("");
  };

  const handleCustomToneChange = (e) => {
    const customValue = e.target.value;
    setFormData((prev) => ({ ...prev, tone: customValue }));
    updateAPI(3, "tone", customValue);
  };

  return (
    <>
      {/* QUESTION 4 */}
      <div className="onboarding-body-global">
        <div className="step0-writing-heading" style={{paddingBottom: "50px"}}>
          What’s Your Writing Style?
        </div>
        <div className="step0-onboarding-heading">
          How should your comments sound?
        </div>
        <div
          style={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
          className="onboarding-Wrapper-container"
        >
          <OnboardingSelect
            label="Choose your tone of voice"
            options={toneData}
            selectedValue={isOtherSelected ? "Other" : formData.tone}
            onChange={handleToneChange}
            isFirstTime={isFirstTime}
          />

          {formData.tone !== "" && isOtherSelected && (
            <OnboardingInput
              placeholder="Write your own"
              value={formData.tone === "Other" ? "" : formData.tone}
              cutomHandler={true}
              onChange={handleCustomToneChange}
            />
          )}

          {stepInfo.step === 3 && stepInfo.message && (
            <div className="info-message-onboarding">{stepInfo.message}</div>
          )}

          {thirdQuestionError && <div className="error-message-onboarding">{thirdQuestionError}</div>}

          {error && <div className="error-message-onboarding">{error}</div>}
          <div
            className="onboarding-below-buttons"
            style={{ marginTop: "22px", marginBottom: "27px" }}
          >
            <OnboardingButton
              style={{
                width: "177px",
                height: "55px",
                boxSizing: "border-box",
              }}
              onClick={() => setStep(1)}
              title="Back"
            />
            <OnboardingButton
              style={{
                width: "177px",
                height: "55px",
                boxSizing: "border-box",
              }}
              onClick={() => {
                if (!formData.tone || formData.tone.trim() === "") {
                  setThirdQuestionError("Please select or enter your tone before continuing.");
                  return;
                };

                setStep(3)
              }}
              title="Next"
              variant="hollow"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step2;
